module.exports = __webpack_public_path__ + "static/media/logo512.5d888f1c.svg";